import * as Sentry from '@sentry/react'
import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { authStore } from '~/shared/api'

export const SentryGate = createGate()
export const domain = createDomain('shared.lib.sentryModel')

export const setUserPhone = domain.createEvent<string>()
export const setUserPhoneFx = domain.createEffect<string, void>({
  async handler(phone) {
    Sentry.setUser({ phone })
  },
})

sample({
  clock: setUserPhone,
  target: setUserPhoneFx,
})

sample({
  clock: SentryGate.open,
  filter: () => Boolean(authStore.phone),
  fn() {
    return authStore.phone
  },
  target: setUserPhoneFx,
})

export const clearUser = domain.createEvent()
export const clearUserFx = domain.createEffect({
  async handler() {
    Sentry.setUser({ phone: '-' })
  },
})

sample({
  clock: clearUser,
  target: clearUserFx,
})
